/* unplugin-vue-components disabled */import { render } from "./CashPage.vue?vue&type=template&id=22219dc0&scoped=true"
import script from "./CashPage.vue?vue&type=script&lang=js"
export * from "./CashPage.vue?vue&type=script&lang=js"

import "./CashPage.vue?vue&type=style&index=0&id=22219dc0&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22219dc0"]])

export default __exports__